import { useState, useEffect, useCallback } from 'react';
export function useCheckHeightIsBigger(ref, minHeight) {
    const [isBigger, setIsBigger] = useState(false);
    const [height, setHeight] = useState();
    const resizeHandler = useCallback(() => {
        const { clientHeight } = ref.current || {};
        if (height !== clientHeight) {
            setHeight(clientHeight);
        }
    }, [ref, height]);
    useEffect(() => {
        window.addEventListener('resize', resizeHandler);
        resizeHandler();
        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, [resizeHandler]);
    useEffect(() => {
        if (height) {
            if (height > minHeight) {
                setIsBigger(true);
            }
            else {
                setIsBigger(false);
            }
        }
    }, [height, minHeight]);
    return isBigger;
}
